import React from 'react';
import { injectedComponent } from '@base/core';
import { ONLY_TECH_COOKIES, ALL_COOKIES } from '../configs/constants';
import initGoogle from '../../../shared/components/google';
import { initYandexMetrika } from '../../../shared/components/yandex';
import { initMailRuTop } from '../../../shared/components/mailRu';
import { noScriptTags } from '../../../shared/components/noScriptTags';
import initPixel from './cookies-agreement-content/pixel';

const PRODUCTION = 'production';

export function handleCookiesAgreement(cookiesAgreement) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const canInitCookiesAgreement =
    process.env.NODE_ENV === PRODUCTION || params.platform === PRODUCTION;
  if (cookiesAgreement === ALL_COOKIES && canInitCookiesAgreement) {
    initGoogle();
    initPixel();
    initYandexMetrika();
    initMailRuTop();
    noScriptTags();
  }
}

export default injectedComponent(
  {
    name: 'CookieAgreementContent',
    services: ['notifier', 'settings'],
    styles: ['self'],
  },
  function CookieAgreementContent({
                                    id,
                                    privacyNoticeUrl,
                                    services: {
                                      notifier,
                                      settings: {
                                        keys: { cookiesAgreementKey },
                                      },
                                    },
                                    styles: { self: selfStyles },
                                  }) {
    const handleAllCookiesAgreement = () => {
      localStorage.setItem(cookiesAgreementKey, ALL_COOKIES);
      notifier.close(id);
      handleCookiesAgreement(ALL_COOKIES);
    };
    console.log('cookiesPolicyUrl:', privacyNoticeUrl);
    return (
      <div className={selfStyles.root}>
        <div className={selfStyles.text}>
          Продолжая пользоваться сайтом, вы соглашаетесь на обработку файлов cookie
        </div>
        <div className={selfStyles.buttonContainer}>
          <a href={privacyNoticeUrl} target="_blank" className={selfStyles.button}>
            Подробнее
          </a>
          <a className={selfStyles.button} onClick={handleAllCookiesAgreement}>
            Принять
          </a>
        </div>
      </div>
    );
  },
);
